import axios from "axios";
export function request(config) {
    return config;
}
export function createRequestError(error) {
    var _a, _b, _c;
    var axiosErr = error;
    var axiosRes = error;
    var data = ((_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _a === void 0 ? void 0 : _a.data) || (axiosRes === null || axiosRes === void 0 ? void 0 : axiosRes.data);
    var code = 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (data === null || data === void 0 ? void 0 : data.code) ||
        (axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.code) ||
        ((_b = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _b === void 0 ? void 0 : _b.status) ||
        (axiosRes === null || axiosRes === void 0 ? void 0 : axiosRes.status);
    var message = (axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.message) || ((_c = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _c === void 0 ? void 0 : _c.statusText) || (axiosRes === null || axiosRes === void 0 ? void 0 : axiosRes.statusText);
    return {
        code: code,
        data: data,
        message: message,
        isCancel: axios.isCancel(error),
        original: error,
    };
}
